import {
  RaidPlanEncounterAssignmentAbility,
  RaidPlanEncounterAssignmentAbilityKey,
} from 'app/frontend/types/custom/RaidPlan'
import { getRequest, putRequest } from './index'

export type DevAssignmentEncounter = {
  id: number
  name: string
}

export type DevAssignmentInstance = {
  id: number
  name: string
  gameVersion: string
  encounters: DevAssignmentEncounter[]
}

export type DevRaidPlanAssignmentDefaults = {
  abilities: Record<
    RaidPlanEncounterAssignmentAbilityKey,
    RaidPlanEncounterAssignmentAbility
  >
  ability_order: RaidPlanEncounterAssignmentAbilityKey[]
}

export const getDevRaidPlanAssignmentInstances = async () => {
  return getRequest('/dev/api/raid_plan_assignment_defaults') as Promise<{
    instances: DevAssignmentInstance[]
  }>
}

export const getDevRaidPlanAssignmentDefaults = async (encounterId: number) => {
  return getRequest(
    `/dev/api/raid_plan_assignment_defaults/${encounterId}`,
  ) as Promise<DevRaidPlanAssignmentDefaults>
}

export const saveDevRaidPlanAssignmentDefaults = async (
  encounterId: number,
  data: DevRaidPlanAssignmentDefaults,
) => {
  return putRequest(`/dev/api/raid_plan_assignment_defaults/${encounterId}`, {
    abilities: data.abilities,
    ability_order: data.ability_order,
  }) as Promise<DevRaidPlanAssignmentDefaults>
}
